<template>
    <article class="prod-li sectls">
        <div class="prod-li-inner">
            <a :href="`/productos/${item.options.slug}`" class="prod-li-img">
                <img v-if="item.options.image" :src="`${item.options.image}`" alt="">
            </a>
            <div class="prod-li-cont">
                <div class="prod-li-ttl-wrap">
                    <p>
                        <a v-if="item.options.category" :href="`/categorias/${item.options.category.slug}/productos`">{{ item.options.category.name }}</a>
                    </p>
                    <h3><a :href="`/productos/${item.options.slug}`">{{ item.name }}</a></h3>
                </div><!--No Space--><div class="prod-li-prices">
                    <div class="prod-li-price-wrap">
                        <p>Precio</p>
                        <p class="prod-li-price">${{ item.price }}</p>
                    </div>
                    <div class="prod-li-qnt-wrap">
                        <p class="qnt-wrap prod-li-qnt">
                            <a v-if="showControls" @click.prevent="up" href="#" class="qnt-plus prod-li-plus"><i class="icon ion-arrow-up-b"></i></a>
                            <input class="mt-1" type="text" v-model="qty" :readonly="!showControls">
                            <a v-if="showControls" @click.prevent="down" href="#" class="qnt-minus prod-li-minus"><i class="icon ion-arrow-down-b"></i></a>
                        </p>
                    </div>
                    <div class="prod-li-total-wrap">
                        <p>Total</p>
                        <p class="prod-li-total">${{ item.subtotal | round }}</p>
                    </div>
                </div>
                <!--
                    No Space
                    -->
            </div>
            <div v-if="showControls" class="prod-li-info">
                <!-- <div class="prod-li-rating-wrap">
                    <p data-rating="2" class="prod-li-rating">
                        <i class="rating-ico" title="1"></i><i class="rating-ico" title="2"></i><i class="rating-ico" title="3"></i><i class="rating-ico" title="4"></i><i class="rating-ico" title="5"></i>
                    </p>
                    <p class="prod-li-rating-count">32</p>
                </div> -->
                <p class="prod-li-add">
                    <a @click.prevent="remove" href="#" class="button hover-label prod-addbtn"><i class="icon ion-close-round"></i><span>Quitar</span></a>
                </p>
                <!-- <p class="prod-li-compare">
                    <a href="compare.html" class="hover-label prod-li-compare-btn"><span>Compare</span><i class="icon ion-arrow-swap"></i></a>
                </p>
                <p class="prod-quickview">
                    <a href="#" class="hover-label quick-view"><i class="icon ion-plus"></i><span>Quick View</span></a>
                </p>
                <div class="prod-li-favorites">
                    <a href="wishlist.html" class="hover-label add_to_wishlist"><i class="icon ion-heart"></i><span>Add to Wishlist</span></a>
                </div>
                <p class="prod-li-information">
                    <a href="#" class="hover-label"><i class="icon ion-more"></i><span>Show Information</span></a>
                </p> -->
            </div>
            <!-- <p class="prod-li-badge"><span>Sale</span></p> -->
        </div>
        <!-- <div class="page-styling prod-li-informations">
            <dl class="prod-li-props">
                <dt>Brand:</dt>
                <dd><a href="#">HOOK</a></dd>
                <dt>Weight:</dt>
                <dd>1 kg</dd>
                <dt>Dimensions:</dt>
                <dd>4 x 50 cm</dd>
                <dt>Сolor:</dt>
                <dd><a href="#">Black</a>, <a href="#">Green</a></dd>
                <dt>Manufacturer:</dt>
                <dd><a href="#">France</a></dd>
                <dt>Material:</dt>
                <dd><a href="#">Metall</a></dd>
            </dl>
        </div> -->
    </article>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        showControls: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            qty: this.item.qty,
        };
    },

    mounted() {
        this.update = _.debounce(this.update, 500);
    },

    methods: {
        up() {
            this.qty++;
            this.update();
        },

        down() {
            if (this.qty > 1) {
                this.qty--;
            }
            this.update();
        },

        update() {
            this.$inertia.patch(`/cart/${this.item.rowId}`, {qty: this.qty}, {
                preserveState: false,
                preserveScroll: true,
            })
        },

        remove() {
            this.$inertia.delete(`/cart/${this.item.rowId}`);
        },

    },

    filters: {
        round(value) {
            return _.round(value, 2);
        }
    }
}
</script>
